import React, { FunctionComponent, Dispatch } from "react";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  ExpansionPanelDetails,
  makeStyles,
  Card,
  CardContent
} from "@material-ui/core";

import { connect, ConnectedProps } from "react-redux";
import {
  deleteAddFriendRequest,
  refuseAddFriendRequest,
  acceptAddFriendRequest,
  deleteFriend
} from "../../redux/actions/FriendsActions";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { SpanButton } from "./SpanButton";
import { friendActionInterface } from "../../redux/reducers/FriendsReducers";
import { ProfileInterface } from "../../redux/reducers/ProfileReducers";
import { FRIEND_REQUEST_BG } from "../../constants/colors";

interface actionsType {
  deleteAddFriendRequest: (
    id: string,
    username: string,
    currentUserName: string
  ) => (dispatch: Dispatch<friendActionInterface>) => void;
  refuseAddFriendRequest: (
    id: string,
    username: string,
    currentUserName: string
  ) => (dispatch: Dispatch<friendActionInterface>) => void;
  acceptAddFriendRequest: (
    otherId: string,
    otherUsername: string,
    currentUserName: string
  ) => (dispatch: Dispatch<friendActionInterface>) => void;
  deleteFriend: (
    otherId: string,
    otherUserUserName: string,
    currentUserName: string
  ) => (dispatch: Dispatch<friendActionInterface>) => void;
}
interface RootState {
  profile: ProfileInterface;
}

const actionsReducers: actionsType = {
  deleteAddFriendRequest,
  refuseAddFriendRequest,
  acceptAddFriendRequest,
  deleteFriend
};

const mapStateToProps = (state: RootState) => ({
  profile: state.profile
});

type PropsFromRedux = ConnectedProps<typeof connector>;

const connector = connect(mapStateToProps, actionsReducers);

interface ExpansionFriendRequestsProps {
  isExpanded: boolean;
  onChange?: (event: React.ChangeEvent<{}>, expanded: boolean) => void;
  title: string;
  message: string;
  type: string;
  requests: {
    count: number;
    data: { [key: string]: string };
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "80%",
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  }
}));

const ExpansionFriendRequests: FunctionComponent<ExpansionFriendRequestsProps &
  PropsFromRedux> = (props) => {
  const classes = useStyles();

  function deleteFriend(uid: string, username: string) {
    if (props.profile.info) {
      props.deleteFriend(uid, username, props.profile.info.username);
    }
  }

  function deleteAddFriendRequest(uid: string, username: string) {
    if (props.profile.info) {
      props.deleteAddFriendRequest(uid, username, props.profile.info.username);
    }
  }

  function refuseAddFriendRequest(uid: string, username: string) {
    if (props.profile.info) {
      props.refuseAddFriendRequest(uid, username, props.profile.info.username);
    }
  }

  function acceptAddFriendRequest(uid: string, username: string) {
    if (props.profile.info) {
      props.acceptAddFriendRequest(uid, username, props.profile.info.username);
    }
  }

  function checkForRequests(
    dictionaryRequest: {
      count: number;
      data: { [key: string]: string };
    },
    message: string,
    type?: string
  ) {
    const dictClone = { ...dictionaryRequest.data };
    const count = dictionaryRequest.count;
    if (count === 0 || dictionaryRequest.data === undefined) {
      return <div>{message} </div>;
    } else {
      delete dictClone.test;
      return Object.keys(dictClone).map((key) => {
        return (
          <Card
            style={{
              marginTop: 10,
              backgroundColor: FRIEND_REQUEST_BG,
              width: "100%"
            }}
            key={key}
          >
            <CardContent className="jsa" style={{ lineHeight: "40px" }}>
              {key}{" "}
              {type === "requests_sent" && (
                <SpanButton
                  onClick={() => deleteAddFriendRequest(dictClone[key], key)}
                  className="btn btn-dark"
                  content="X"
                />
              )}
              {type === "requests_received" && (
                <div>
                  <SpanButton
                    onClick={() => refuseAddFriendRequest(dictClone[key], key)}
                    className="btn btn-secondary"
                    content="X"
                  />
                  <SpanButton
                    style={{ marginLeft: 10 }}
                    onClick={() => acceptAddFriendRequest(dictClone[key], key)}
                    className="btn btn-primary"
                    content="✓"
                  />
                </div>
              )}
              {type === "all_friends" && (
                // || type === "online_friends"
                <SpanButton
                  onClick={() => deleteFriend(dictClone[key], key)}
                  className="btn btn-dark"
                  content="delete"
                />
              )}
            </CardContent>
          </Card>
        );
      });
    }
  }

  return (
    <ExpansionPanel expanded={props.isExpanded} onChange={props.onChange}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography className={classes.heading}>{props.title}</Typography>
        <Typography className={classes.secondaryHeading}>
          {props.requests.count}
        </Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails style={{ display: "block" }}>
        {checkForRequests(props.requests, props.message, props.type)}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default connector(ExpansionFriendRequests);
